// @ts-nocheck
const inputRegex = /[^a-zA-Z0-9,@"/_. -]/g;
const searchIgnoreCharacters = /[,\s.]/g;
export { inputRegex, searchIgnoreCharacters };